import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

/** AU 版页面结构不同，锚点指向对应的 SectionLeftInfo 板块 */
const AU_ANCHORS = ['#outdoor-recreation-power-generation', '#outdoor-recreation-power-storage', '#outdoor-recreation-power-usage'];

export default function C_Other() {
    const { useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    const IS_AU = locale === 'au';
    const cards: any = [
        {
            img: '/responsive/picture/common-products/power_generation.png',
            title: t('secC_list1_title'),
            desc: t('secC_list1_desc'),
            link: t('secC_list1_link'),
            url: IS_AU ? AU_ANCHORS[0] : '#outdoor-recreation-G',
            text: t('secC_text'),
        },
        {
            img: '/responsive/picture/common-products/power_storage.png',
            title: t('secC_list2_title'),
            desc: t('secC_list2_desc'),
            link: t('secC_list2_link'),
            url: IS_AU ? AU_ANCHORS[1] : '#outdoor-recreation-D',
            text: t('secC_text'),
        },
        {
            img: `/responsive/picture/common-products/power_usage${locale === 'za' ? '_za' : ''}.png`,
            title: t('secC_list3_title'),
            desc: t('secC_list3_desc'),
            link: t('secC_list3_link'),
            url: IS_AU ? AU_ANCHORS[2] : '#outdoor-recreation-J',
        },
    ];

    return (
        <div id="outdoor-recreation-C" className={`outdoor-recreation-C ${css['outdoor-recreation-C']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secC_title')}</p>
                    <p className="desc">{t('secC_desc')}</p>
                </div>
                <ul className="card-box">
                    {cards?.map((card: any, k: number) => (
                        <li className="card" key={k}>
                            {card?.text && (
                                <div className="electric-energy">
                                    <p className="energy-text">{card?.text}</p>
                                    <p className="energy-line"></p>
                                </div>
                            )}
                            <div className="card-img">
                                <EFPicture src={card?.img} alt={card?.title} />
                            </div>
                            <div className="card-text">
                                <p className="card-title">{card?.title}</p>
                                <p className="card-desc">{card?.desc}</p>
                                <a
                                    href={card?.url}
                                    className="card-link"
                                    onClick={() =>
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_preview',
                                            button_name: card?.link,
                                        })
                                    }
                                >
                                    <span className="link-text">{card?.link}</span>
                                    <svg className="link-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M8.99844 15.8999C7.09324 15.8999 5.36825 15.1275 4.11955 13.8788C2.87085 12.6301 2.09844 10.9051 2.09844 8.9999C2.09844 7.0947 2.87085 5.36971 4.11955 4.12102C5.36825 2.87232 7.09324 2.0999 8.99844 2.0999C10.9036 2.0999 12.6286 2.87232 13.8773 4.12101C15.126 5.36971 15.8984 7.0947 15.8984 8.9999C15.8984 10.9051 15.126 12.6301 13.8773 13.8788C12.6286 15.1275 10.9036 15.8999 8.99844 15.8999Z"
                                            stroke="#3F68E0"
                                            strokeWidth="1.41429"
                                        />
                                        <path
                                            d="M11.9961 8.99988L8.99609 11.9999L5.99609 8.99988M8.99609 10.8749L8.99609 5.99988"
                                            stroke="#3F68E0"
                                            strokeWidth="1.41429"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </a>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
